<template>
  <div>
    <!-- 优惠劵 -->
    <baseBreadcrumb :page="$t('message.coupons')" :menu="$t('message.moneyManagement')"></baseBreadcrumb>
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.discount_status" type="card" @tab-click="handleClick">
          <!-- 待发放 -->
          <el-tab-pane :label="$t('message.stayOut')" name="0"></el-tab-pane>
          <!-- 已发放 -->
          <el-tab-pane :label="$t('message.ssued')" name="1"></el-tab-pane>
          <!-- 已使用 -->
          <el-tab-pane :label="$t('message.hasBeenUsed')" name="2"></el-tab-pane>
          <!-- 已过期 -->
          <el-tab-pane :label="$t('message.expired')" name="-1"></el-tab-pane>
        </el-tabs>
        <div class="btn">
          <!--  优惠券模板设置 -->
          <el-button type="primary" class="primary" size="small" @click="couponTemplate">{{ $t("message.couponTemplate")
          }}</el-button>
          <!--  优惠券生成-->
          <el-button type="primary" class="primary" size="small" @click="couponsSpecifieds" v-if="isAuth(472)">{{
            $t("message.couponsSpecifieds") }}</el-button>
          <!-- 批量发放 -->
          <el-button type="primary" class="primary" size="small" @click="batchIssue"
            v-if="datas.discount_status == 0 && isAuth(471)">{{ $t("message.batchIssue") }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%" @selection-change="handleSelectionChange"
          ref="multipleTable" @cell-click="labelSelection" size="small" v-if="show">
          <el-table-column type="index" width="60" align="center" label="NO">
          </el-table-column>
          <el-table-column type="selection" width="60" align="center" v-if="datas.discount_status == 0">
          </el-table-column>
          <!-- 订单/配送单号 -->
          <el-table-column align="center" :label="$t('message.orderDistribution')" width="180"
            v-if="datas.discount_status == 2">
            <template slot-scope="scope">
              {{
                scope.row.use_order_sn
                  ? scope.row.use_order_sn
                  : scope.row.use_porder_sn
              }}
            </template>
          </el-table-column>
          <!-- 金额 -->
          <el-table-column align="center" :label="$t('message.sum')" prop="initial_amount"
            v-if="datas.discount_status == 2">
          </el-table-column>
          <!-- 实际支付金额 -->
          <el-table-column align="center" :label="$t('message.actualAmountPaid')" prop="ultimately_amount"
            v-if="datas.discount_status == 2">
          </el-table-column>
          <!-- 使用时间 -->
          <el-table-column align="center" :label="$t('message.useTime')" prop="use_datetime" width="82"
            v-if="datas.discount_status == 2">
          </el-table-column>
          <!-- 券名称 -->
          <el-table-column align="center" :label="$t('message.couponName')" prop="name_translation">
          </el-table-column>
          <!-- 券码编号 -->
          <el-table-column align="center" :label="$t('message.couponNunber')" prop="sn" width="200">
          </el-table-column>

          <!-- 有效日期 -->
          <el-table-column align="center" :label="$t('message.effectiveDate')" width="250">
            <template slot-scope="scope">
              <p>
                {{ $t("message.startDate") }} {{ scope.row.effective_date }}
              </p>
              <p>{{ $t("message.dateClosed") }} {{ scope.row.expiry_date }}</p>
            </template>
          </el-table-column>
          <!-- 类别 -->
          <el-table-column align="center" :label="$t('message.category')">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }">{{
                scope.row.type_name
              }}</span>
            </template>
          </el-table-column>
          <!-- 额度/可用次数/折扣比例 -->
          <el-table-column align="center" label="额度/可用次数/折扣比例/天" width="150">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.type == 1 ? '#2C96E7' : '#B4272D' }" v-if="scope.row.type != '3'">
                {{ scope.row.discounts_amount_jpy }}
              </span>
              <span v-else>
                <!-- {{ scope.row }} -->
                {{
                  scope.row.discounts_amount_jpy &&
                    scope.row.discounts_amount_jpy != "0"
                    ? scope.row.discounts_amount_jpy
                    : scope.row.discounts_rate + "%"
                }}</span>
            </template>
          </el-table-column>

          <!-- 使用限制 -->
          <el-table-column align="center" :label="$t('message.useRestrictions')">
            <template slot-scope="scope">
              <div v-if="scope.row.type <= 3">

                <span v-if="scope.row.type != '3'">1订单金额 >={{ scope.row.min_consumption_jpy }}</span>
                <div v-else>
                  <p>订单金额 >={{ scope.row.min_consumption_jpy }}</p>
                  <p>计费重量 >={{ scope.row.min_weight }}</p>
                  <p>
                    <el-select :disabled="true" v-model="scope.row.logistics_id" multiple placeholder="全部物流">
                      <el-option v-for="(yitem, oindex) in Logisticsoptions" :key="oindex" :label="yitem.name"
                        :value="yitem.id">
                      </el-option>
                    </el-select>
                  </p>
                </div>
              </div>
              <div v-else>
                无
              </div>
            </template>
          </el-table-column>
          <!--  申请人-->
          <el-table-column align="center" :label="$t('message.theApplicant')" prop="apply_by">
            <template slot-scope="scope">
              <span v-if="scope.row.apply_by == 0">
                系统发放
              </span>
              <span v-else>
                {{ scope.row.apply_admin.realname }}
              </span>
            </template>
          </el-table-column>
          <!--  申请原因-->
          <el-table-column align="center" :label="$t('message.reasonForApplication')" prop="apply_reason">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')" v-if="datas.discount_status == 0">
            <template slot-scope="scope">
              <!-- 发放 -->
              <p style="margin-bottom: 10px">
                <el-button size="small" type="primary" class="primary" @click="sendDiscount(scope.row.id)"
                  v-if="isAuth(472)">{{ $t("message.issue") }}</el-button>
              </p>
              <!-- 删除 -->
              <p>
                <el-button size="small" type="primary" class="dark" @click="delItem(scope.row.id)" v-if="isAuth(473)">
                  {{ $t("message.delete") }}
                </el-button>
              </p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 劵模板 -->
    <templateSettings ref="templateSettings" />
    <!-- 优惠券生成 -->
    <generateCoupon ref="generateCoupon" />
  </div>
</template>
<script>
import templateSettings from "./components/templateSettings";
import generateCoupon from "./components/generateCoupon";

export default {
  components: { templateSettings, generateCoupon },
  data() {
    return {
      datas: {
        discount_status: "0",
        page: 1,
        pageSize: 10,
        user_id: this.$route.query.userID,
      },
      total: 0,
      tableData: [],
      show: false,
      selectList: [],
      Logisticsoptions: [],
    };
  },

  created() {
    this.getDiscount();
    this.$api.clienteleApi.getDiscountLogistics().then((res) => {
      res.data.forEach((element) => {
        element.id = element.id + "";
      });
      this.Logisticsoptions = res.data;
    });
  },
  methods: {
    getDiscount() {
      this.show = false;
      this.$api.clienteleApi.getDiscount(this.datas).then((res) => {
        res.data.data.forEach((dataItem) => {
          if (dataItem.logistics_id) {
            let arr = dataItem.logistics_id.split(",");
            dataItem.logistics_id = arr;
            dataItem.logistics = 1;
          } else {
            dataItem.logistics = 0;
          }
          if (!isNaN(dataItem.min_weight)) {
            dataItem.min_weight = Number(dataItem.min_weight);
          }
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.selectList = [];
        this.show = true;
      });
    },
    handleClick() {
      this.datas.page = 1;
      this.getDiscount();
    },
    // 整个框选择
    labelSelection(row, column) {
      if (column.className == "el-table-column--selection") {
        this.$refs.multipleTable.toggleRowSelection(row);
      }
    },
    handleSelectionChange(val) {
      this.selectList = val;
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.getDiscount();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.getDiscount();
    },
    // 优惠券模板设置
    couponTemplate() {
      this.$refs.templateSettings.dialogVisible = true;
    },
    // 优惠券生成
    couponsSpecifieds() {
      this.$refs.generateCoupon.dialogVisible = true;
    },
    // 删除优惠券
    delItem(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            user_id: this.$route.query.userID,
            id,
          };
          this.$api.clienteleApi.deleteDiscount(datas).then((res) => {
            this.$message.success(res.msg);
            this.getDiscount();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 发放 优惠券
    sendDiscount(id) {
      this.$confirm(
        this.$t("message.issueCoupons"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            user_id: this.$route.query.userID,
            id,
          };
          this.$api.clienteleApi.sendDiscount(datas).then((res) => {
            this.$message.success(res.msg);
            this.getDiscount();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    //批量发放 优惠劵
    batchIssue() {
      if (this.selectList == false)
        return this.$message.error(
          this.$t("message.pleaseSelectTheCouponToBeIssued")
        );
      let ids = [];
      this.selectList.forEach((item) => {
        ids.push(item.id);
      });
      ids = ids.join(",");
      this.sendDiscount(ids);
    },
    y(id) {
      let name = this.$store.state.authWorkGroupAdmin.y.find(item => item.id == id).realname
      return name
    }
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  position: relative;

  .btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}

/deep/.cell {
  padding: 3px;
}
</style>
